import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type reverseTrialPopupQuery,
} from './__generated__/reverseTrialPopupQuery.graphql';

export type EntryPointParams = {
	cloudId: string;
	hamsProductKey: string;
};

type ReverseTrialPopupComponent = EntryPointComponent<
	{
		reverseTrialPopupQuery: reverseTrialPopupQuery;
	},
	Record<string, never>,
	{
		onClose: (extraInformation?: unknown) => void;
	},
	Record<string, never>
>;

export const entryPoint: EntryPoint<ReverseTrialPopupComponent, EntryPointParams> =
	createEntryPoint({
		root: JSResourceForInteraction<ReverseTrialPopupComponent>(
			/* webpackChunkName: "@atlaskit-internal_edition-awareness-reverse-trial-popup" */ './reverse-trial-popup',
			{
				moduleId: 'edition-awareness-reverse-trial-popup',
			},
		),
		getPreloadProps: ({ cloudId, hamsProductKey }: EntryPointParams) => ({
			entryPoints: {},
			extraProps: {},
			queries: {
				reverseTrialPopupQuery: {
					parameters,
					variables: {
						cloudId,
						hamsProductKey,
					},
				},
			},
		}),
	});
